export default __webpack_public_path__ + "static/media/hero-bg-desktopSmall.8d35c89d.png";